import { render, staticRenderFns } from "./agreement3.vue?vue&type=template&id=2e29d6aa&scoped=true"
var script = {}
import style0 from "./agreement3.vue?vue&type=style&index=0&id=2e29d6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29d6aa",
  null
  
)

export default component.exports